import Repository from './Repository';
const resource = '/v1/customer/payment_detail';

export default {
//   postInfo(payload) {
//     return new Promise((resolve, reject) => {
//       Repository.post(`${resource}`, payload)
//         .then(response => {
//           resolve(response);
//         })
//         .catch(error => {
//           reject(error.response);
//         });
//     });
//   },
  getPaymentDetail(id) {
    return new Promise((resolve, reject) => {
      Repository.get(`${resource}/${id}`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error.response);
        });
    });
  }
}
